import { AVATARS } from "../lib/constants";

export default function EmojiPicker({ value, onChange, testIdPrefix = "avatar-option" }) {
  return (
    <div className="grid grid-cols-4 gap-3" data-testid="emoji-picker-grid">
      {AVATARS.map((e) => {
        const selected = value === e;
        return (
          <button
            type="button"
            key={e}
            onClick={() => onChange(e)}
            data-testid={`${testIdPrefix}-${e}`}
            className={`emoji-cell ${selected ? "selected" : ""} h-16 rounded-2xl bg-white border border-[#e9ecef] flex items-center justify-center text-3xl`}
            aria-pressed={selected}
            aria-label={`Avatar ${e}`}
          >
            <span>{e}</span>
          </button>
        );
      })}
    </div>
  );
}
